/**
 * Vuetify is configured via ml-components' MLVuetifyConfig which encodes the
 * Medlive light + dark themes, type scale, and component defaults. We only
 * override here when we need an app-specific tweak.
 */
import { createVuetify } from 'vuetify'
import { MLVuetifyConfig } from '@medlive-tech/ml-components'

export default createVuetify({
  ...MLVuetifyConfig,
  defaults: {
    ...(MLVuetifyConfig.defaults ?? {}),
    VBtn: { rounded: 'sm', ...(MLVuetifyConfig.defaults?.VBtn ?? {}) },
  },
})
